import React from 'react';
import { graphql, Link } from 'gatsby';
import Layout from '../components/layout';

function ProductCategory({data}) {
	const products = data.markdownRemark;
	return (
		<Layout>
			<h3 className="productTitle">{products.frontmatter.title}</h3>
			<div dangerouslySetInnerHTML={{ __html: products.html }}></div>
			<Link to="/products/" className="returnLink">Return to products page</Link>
		</Layout>
	);
}

export default ProductCategory;

export const query = graphql`
	query($slug: String!) {
		markdownRemark(fields: {slug: {eq: $slug}}) {
			html
			frontmatter {
				title
			}
		}
	}
`